<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.Params.Key"
          style="width: 15%"
          placeholder="姓名/昵称/手机号/证件号"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-dropdown
          split-button
          @click="onLoad"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column label="头像" width="70" align="center">
          <template #default="{ row }">
            <el-image
              :src="onFormatUrl(row.WxPhoto)"
              :preview-src-list="row.WxPhoto ? [onFormatUrl(row.WxPhoto)] : []"
              preview-teleported
              fit="cover"
              style="
                width: 36px;
                height: 36px;
                border-radius: 50%;
                cursor: pointer;
              "
            >
              <template #error>
                <el-avatar :size="36">
                  <el-icon><UserFilled /></el-icon>
                </el-avatar>
              </template>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="Id" label="用户ID" width="80" align="center" />
        <el-table-column prop="Xm" label="姓名"> </el-table-column>
        <el-table-column
          prop="NickName"
          label="昵称"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="Sjhm"
          label="手机号码"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="Xb"
          label="性别"
          :formatter="$tab_StatusFormat"
        />
        <el-table-column
          prop="AppID"
          label="微信OpenID"
          width="180"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="FirstLoginTime"
          label="首次登录"
          width="160"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="LastLoginTime"
          label="最后登录"
          width="160"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="状态" width="90" align="center">
          <template #default="{ row }">
            <el-tag v-if="row.IsHmd" type="danger">已拉黑</el-tag>
            <el-tag v-else type="success">正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="Cjsj"
          label="注册时间"
          width="160"
          :formatter="$tab_TextFormat"
        />
      </el-table>
    </ul>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.PageIndex"
      @onLoad="
        (pageIndex) => {
          state.params.PageIndex = pageIndex;
          onLoad();
        }
      "
    >
    </c_page>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { youke_xcxlist } from "@/http/api";
import { RefreshLeft } from "@element-plus/icons-vue";

export default {
  setup() {
    const state = reactive({
      params: {
        PageSize: 20,
        PageIndex: 1,
        Params: { Key: null },
        Order: "Id",
        Asc: false,
      },
    });

    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      youke_xcxlist(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //头像地址补全（OSS 全地址直接使用，本地相对路径拼接 API 地址）
    const onFormatUrl = (url) => {
      if (!url) return "";
      if (url.indexOf("http") == 0) return url;
      return window.apiUrl + url;
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, {
        params: {
          PageSize: 20,
          PageIndex: 1,
          Params: { Key: null },
          Order: "Id",
          Asc: false,
        },
      });
      onLoad();
    };

    return {
      state,
      onLoad,
      onReset,
      onFormatUrl,
      RefreshLeft,
    };
  },
};
</script>
